import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {GoogleAnalyticsEventsService} from "./google-analytics-service";
import * as $ from 'jquery';
import * as Headroom from 'headroom.js';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewChecked {
    public currentPage;

    constructor(public router: Router, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) {

        Headroom.options.offset = 60;
        Headroom.options.tolerance = 5;

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.googleAnalyticsEventsService.emitEvent('page', event.urlAfterRedirects);
                this.currentPage = event.url.replace('/', '');
                this.currentPage = this.currentPage == '' ? 'portfolio' : this.currentPage;
            }
            this.closeNav();
        });
    }

    ngOnInit() {
        let headroom = new Headroom(document.querySelector("#navbar"));
        headroom.init();
    }

    ngAfterViewChecked() {
        if ($('.navbar-collapse').hasClass('show')) {
            $('.navbar-collapse').removeClass('show');
        }
    }

    closeNav(): void {
        if ($(window).width() <= 768) {
            // closes navbar after selection (small device format)
            $('.navbar-toggler').click();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts